<div class="page-wrapper section-hr-direct">
    <app-left-menu [showMenu]="false"></app-left-menu>
    <div id="main-container">
        <app-header [showHistoryButton]="true" [title]="title"></app-header>
        <div class="content-header"> </div>
        <div class="page-content settings">
            <div class="no-absolute m-t30">
                <div class="col-md-10 col-md-push-1">
                    <div class="row">
                        <span *ngIf="error" class="error-message">{{error}}</span>
                        <form [formGroup]="mailingAddressForm"  (submit)="submit(mailingAddressForm.value,mailingAddressForm.valid)">

                            <div class="col-md-6">
                                <label>{{'MailingAddress.MailingAddressLine1.Label'|translate}}<span class="required">*</span>

                                </label>


                                <input type="text" maxlength="256" formControlName="MailingAddressLine1">

                            </div>
                            <div class="col-md-6">
                                <label>{{'MailingAddress.MailingAddressLine2.Label'|translate}}<span class="required">*</span>

                                </label>


                                <input type="text"  maxlength="256" formControlName="MailingAddressLine2">

                            </div>



                            <div class="col-md-6">
                                <label>{{'MailingAddress.City.Label'|translate}}<span class="required">*</span>

                                </label>


                                <input type="text" maxlength="50" formControlName="City">

                            </div>
                            <div class="col-md-6">
                                <label>{{'MailingAddress.State.Label'|translate}}<span class="required">*</span>

                                </label>


                                <input type="text" maxlength="50" formControlName="State">

                            </div>

                            <div class="col-md-6">

                                <label>{{'MailingAddress.Zipcode.Label'|translate}}<span class="required">*</span>

                                </label>


                                <input type="text" maxlength="9" formControlName="Zipcode">
                            </div>
                            <div class="col-md-6">
                                <label>{{'MailingAddress.Contact.Label'|translate}}<span class="required">*</span>

                                </label>


                                <input type="text"  mask="000-000-0000" formControlName="Contact">

                            </div>
                            <div class="col-md-6">
                                <label>{{'MailingAddress.Fax.Label'|translate}}<span class="required">*</span>

                                </label>


                                <input type="text"  mask="000-000-0000" formControlName="Fax">

                            </div>
                            <div class="col-md-12">

                                <button type="submit" class="btn btn-main"
                                    [disabled]="!mailingAddressForm.valid">{{'Common.Submit'|translate}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>